import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a type for the slice state
export interface PostData {
  id: number;
  title: string;
  author_name: string;
  author_image: string;
  description: string;
  short_description: string;
  image: string;
  createdAt: string;
  tag: string;
}

export const postsApi = createApi({
  reducerPath: "postsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api",
  }),
  endpoints: (builder) => ({
    getBlogs: builder.query<PostData[], number>({
      query: (page = 1) => `/blogs?page=${page}&limit=9`,
    }),
    // Define a query to fetch a single post by ID
    getBlogById: builder.query<PostData, number>({
      query: (id) => `/blogs/${id}`,
    }),
    // Define a mutation to create a new post
    createBlog: builder.mutation<PostData, Partial<PostData>>({
      query: (postData) => ({
        url: "/blogs/create",
        method: "POST",
        body: postData,
      }),
    }),
  }),
});

export const { useGetBlogsQuery, useGetBlogByIdQuery, useCreateBlogMutation } =
  postsApi;
